<template>
  <div id="salesforce-auth">
    <div class="center-container">
      <div class="input-container">
        <base-heading>
          Domain
        </base-heading>
        <validation-observer
          ref="form"
        >
          <form
            data-vv-scope="test-form"
            class="needs-validation"
            novalidate
          >
            <input
              ref="domain"
              v-model="domain"
              type="text"
              :class="`mb-3 form-control ${ invalid ? 'is-invalid' : ''}`"
              name="domain"
            >
            <base-button
              id="salesforce-login-button"
              @click="loginHandler"
            >
              Init Store
            </base-button>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { API_ROOT } from '../../config';
import api from '../../_api';
import BaseHeading from '../../components/Base/BaseHeading';

export default {
  name: 'ShopifyStoreInit',
  components: {
    ValidationObserver,
    BaseHeading,
  },
  data() {
    return {
      domain: null,
      url: null,
    };
  },
  methods: {
    loginHandler() {
      api.get(`${API_ROOT}/shopify/init/${this.domain}`).then((r) => {
        window.open(r.data);
      });
    },
  },
};
</script>

<style>
.input-container{
  width: 20%;
  height:10%;
}
.center-container{
  display: flex;
  flex-direction:column;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
  width: 100%;
  height: 100%;
}
.email-input {
  font-size: 0.75rem;
  border: none;
  padding: 0.55rem 2.5rem 0.55rem 0.8125rem ;
  border-radius: 5px;
  min-width: 100%;
}
</style>
